// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1usUm","head":"ProcedureTableInfo_head__1IL_t"};